import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import { TEMPLATE_IMAGE_URL } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import UIClickable from 'UIComponents/button/UIClickable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import styled from 'styled-components';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEMPLATE_IMAGE_HEIGHT = 197;
const TEMPLATE_IMAGE_WIDTH = 264;
const RadioInput = styled(UIRadioInput).withConfig({
  displayName: "TemplatePickerCard__RadioInput",
  componentId: "sc-1lq8rcp-0"
})(["padding:10px;"]);
class TemplatePickerCard extends Component {
  constructor(...args) {
    super(...args);
    this.handleChooseTemplateClick = () => {
      const {
        onChooseTemplateClick,
        templateType
      } = this.props;
      onChooseTemplateClick(templateType);
    };
  }
  render() {
    const {
      currentTemplate,
      templateType,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(UIClickable, {
      "data-test-id": "template-picker-card",
      "data-test-template-type": templateType,
      onClick: this.handleChooseTemplateClick,
      className: className,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${templateType}.title`
          })
        }), /*#__PURE__*/_jsx(UIImage, {
          height: TEMPLATE_IMAGE_HEIGHT,
          src: TEMPLATE_IMAGE_URL[templateType],
          width: TEMPLATE_IMAGE_WIDTH
        }), /*#__PURE__*/_jsx(RadioInput, {
          checked: currentTemplate === templateType
        })]
      })
    });
  }
}
export default TemplatePickerCard;